import type { CameraRoute } from '@datum-sdk/scene-format';

/**
 * The overall preloader flights, as SDK scene data — a tour with no flyover:
 * the exit parks the camera on `previewTourEnd`, and that is the rest pose.
 *
 * Converted once from the legacy `overallSceneConfig.camera` by
 * `convertLegacyPreloader.ts` (which says what in here is load-bearing); the
 * routes are the source since. Tune them in the SDK editor (`?flight` → Routes →
 * Copy Routes) — the same workflow as `kaabaRoutes.ts` — and
 * `sceneRoutes.test.ts` holds them to what the preloader and the scene need.
 *
 * Two centres: the tour turns round the preview cloud's own, and the exit
 * re-aims at the map's (`previewTourEnd.target` = `controls.orbitCenter`) —
 * a route leaves the orbit pivot on the point it last looked at.
 */
export const OVERALL_CAMERA_ROUTES: CameraRoute[] = [
  {
    id: 'preview-enter',
    waypoints: [
      {
        target: [4.331687196, 4.213244437, -1.947665927],
        lookAt: [1.27, 0, -0.18],
        duration: 1000,
        easing: [0.65, 0, 0.35, 1],
      },
      {
        orbit: {
          radius: 5.5,
          azimuth: -0.340339204,
          polar: 0.698131701,
        },
        target: [1.27, 0, -0.18],
        lookAt: 'target',
        duration: 500,
        easing: [0.333333333, 0, 0.666666667, 0.333333333],
      },
    ],
  },
  {
    id: 'preview-turntable',
    loop: true,
    waypoints: [
      {
        orbit: {
          radius: 5.5,
          azimuth: 1.230457123,
          polar: 0.698131701,
        },
        target: [1.27, 0, -0.18],
        lookAt: 'target',
        duration: 2142.857142857,
        easing: 'linear',
      },
      {
        orbit: {
          radius: 5.5,
          azimuth: 2.801253449,
          polar: 0.698131701,
        },
        target: [1.27, 0, -0.18],
        lookAt: 'target',
        duration: 2142.857142857,
        easing: 'linear',
      },
      {
        orbit: {
          radius: 5.5,
          azimuth: 4.372049776,
          polar: 0.698131701,
        },
        target: [1.27, 0, -0.18],
        lookAt: 'target',
        duration: 2142.857142857,
        easing: 'linear',
      },
      {
        orbit: {
          radius: 5.5,
          azimuth: 5.942846103,
          polar: 0.698131701,
        },
        target: [1.27, 0, -0.18],
        lookAt: 'target',
        duration: 2142.857142857,
        easing: 'linear',
      },
    ],
  },
  {
    id: 'preview-exit',
    waypoints: [
      {
        target: [5.82, 2.08, -0.47],
        lookAt: [0.18, 0.03, -0.31],
        duration: 1000,
        easing: [0.65, 0, 0.35, 1],
      },
    ],
  },
];
